import { render, staticRenderFns } from "./client-modal-add-change.vue?vue&type=template&id=cf267196&scoped=true"
import script from "./client-modal-add-change.vue?vue&type=script&lang=js"
export * from "./client-modal-add-change.vue?vue&type=script&lang=js"
import style0 from "./client-modal-add-change.vue?vue&type=style&index=0&id=cf267196&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf267196",
  null
  
)

export default component.exports